var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"bg","mode":"out-in"}},[_c('div',{key:_vm.background_image,staticClass:"o-highlight__background",style:(("background-image: " + (!_vm.background_image ? 'none' : 'url(' + _vm.background_image + ')') + ";"))})])}
var staticRenderFns = []

export { render, staticRenderFns }